import { render } from "./getter-wrapper.vue?vue&type=template&id=5158dcb2&scoped=true"
import script from "./getter-wrapper.js?vue&type=script&lang=js&external"
export * from "./getter-wrapper.js?vue&type=script&lang=js&external"

import "./getter-wrapper.scss?vue&type=style&index=0&id=5158dcb2&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5158dcb2"]])

export default __exports__